<!--
    描述： 上传组件
    时间： 2020-03-23
    created by ws
-->
<template>
	<div class="single-upload-layout">
		<!-- 图片模式 -->
		<template v-if="listType === 'picture-card'">
			<el-upload
				class="upload-demo"
				ref="upload"
				action=""
				:class="{
					'picture-demo': listType === 'picture-card',
					'small-box': msg == '',
					'hidden-upload': maxNum === 1 && fileLength === 1
				}"
				:list-type="listType"
				:disabled="isDisabled"
				:limit="maxNum"
				:on-exceed="onExceed"
				:on-change="onChange"
				:file-list="fileList"
				:multiple="multiple"
				:auto-upload="false"
			>
				<div slot="trigger" v-if="mode !== 'view'">
					<span v-if="msg == ''" class="add"><i class="el-icon-plus"></i></span>
					<img v-if="msg == 'idCardZ'" class="img-con" src="@/assets/images/idCardZ.png" alt="" />
					<img v-if="msg == 'idCardF'" class="img-con" src="@/assets/images/idCardF.png" alt="" />
				</div>
				<!-- 图片模式 -->
				<div slot="file" slot-scope="{ file }" class="picture-box">
					<img class="el-upload-list__item-thumbnail img-size" :src="file.filePath ? `${uploadUrl}${file.filePath}` : file.url" alt="" />
					<span class="el-upload-list__item-actions">
						<em class="mr5 el-icon-zoom-in cursor-pointer" title="查看" @click="doView(file)"></em>
						<em class="mr5 el-icon-download cursor-pointer" title="下载" v-if="file.id" @click="doDownload(file)"></em>
						<em class="el-icon-delete cursor-pointer" title="删除" v-if="mode !== 'view'" @click="doDelete(file)"></em>
					</span>
				</div>

				<div slot="tip" v-if="mode !== 'view' && !hideTip" class="el-upload__tip file-tip">
					<p class="text-overflow text-center mt5">
						<span v-if="msg == 'idCardZ'">身份证（人像面）</span>
						<span v-if="msg == 'idCardF'">身份证（国徽面）</span>
					</p>
				</div>
			</el-upload>
		</template>

		<el-dialog center :visible.sync="dialogObj.visible" title="图片预览">
			<img width="100%" :src="dialogObj.imgUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import { uploadToWeb, saveFile_pay, getFiles_pay, deleteFile_pay } from 'api/modules/upload'
import { dateFormat } from 'utils/tools'

export default {
	name: 'upload_component',
	props: {
		// 当前查看模式
		mode: {
			type: String,
			default: 'add'
		},
		// 最大文件上传个数
		maxNum: {
			type: Number,
			default: 10
		},
		// 上传到那个数据库
		forDatabase: {
			type: String,
			default: ''
		},
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: true
		},
		// 接收的文件类型
		acceptType: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 回显业务表id
		aid: {
			type: String,
			default: ''
		},
		// 业务表名称 --- 由后台表名确定
		tableName: {
			type: String,
			default: 'bus_pro_contract'
		},
		// assortment
		assortment: {
			type: String,
			default: ''
		},
		// 附件模式 (picture-card 和 text 两种)
		listType: {
			type: String,
			default: 'text'
		},
		// 是否需要刷新页面
		needRefresh: {
			type: Boolean,
			default: true
		},
		// 是否隐藏上传格式提醒文字
		hideTip: {
			type: Boolean,
			default: false
		},
		// 控制展示文字
		msg: {
			type: String,
			default: ''
		},
		//
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fileList: [],
			addList: [],
			delList: [],
			isLoaded: false,
			// 文件预览对象
			dialogObj: {
				visible: false,
				imgUrl: ''
			},
			timer: null
		}
	},
	mounted() {
		// 组件加载完毕后 渲染状态
		this.isLoaded = true
		this.aid ? this.getFiles() : ''
	},
	methods: {
		// 文件上传方法 --- 上传数据库
		fileUpload(uploadId, item, params) {
			// 在有上传数据的情况下
			let _aid = uploadId ? uploadId : this.aid

			if (this.timer) {
				clearTimeout(timer)
			}

			let dataParams = {
				path: params.path,
				md5: params.md5,
				size: params.size,
				aid: _aid,
				tableName: this.tableName,
				assortment: this.assortment
			}
			saveFile_pay(dataParams)
				.then((res) => {
					// this.$message.success('附件上传成功！')
					// this.needRefresh ? this.doRefresh() : ''
				})
				.catch((err) => {
					// this.$message.error('附件上传数据库失败！')
					// this.needRefresh ? this.doRefresh() : ''
				})
		},

		// 文件上传到服务器
		fileSend(aid) {
			let that = this
			if (this.addList.length > 0) {
				for (let item of this.addList) {
					let formData = new FormData()
					formData.append('file', item)
					formData.append('path', dateFormat('yyyy-mm-dd'))
					formData.append('output', 'json')
					let nameArr = item.name.split('.')
					let suffix = nameArr[nameArr.length - 1]
					let _name = `${this.$SnowFlake.nextId()}_${this.$generateRandomString()}.${suffix}`
					formData.append('filename', _name)

					uploadToWeb(formData)
						.then((res) => {
							// console.log(res)
							// console.log(aid)
							that.fileUpload(aid, item, res)
							// this.uploadMessage(true)
						})
						.catch((err) => {
							that.$message.error('附件上传服务器失败！')
							// that.doRefresh()
							return false
						})
				}

				// this.$refs.upload.submit()
			} else {
				// this.needRefresh ? this.doRefresh() : ''
			}
		},

		// 数据回显
		getFiles() {
			getFiles_pay({
				aid: this.aid,
				tableName: this.tableName,
				assortment: this.assortment
			})
				.then((res) => {
					this.fileList = res.data
				})
				.catch((err) => {
					this.fileList = []
				})
		},

		// 文件列表变化事件
		onChange(file, fileList) {
			// console.log(file)
			if (file.size / 1024 / 1024 > 1) {
				this.$message.warning('温馨提示：上传文件不超过1M')
				fileList.forEach((x, index) => {
					if (x.uid == file.uid) {
						fileList.splice(index, 1)
					}
				})
			} else {
				let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
				if (this.checkType(curType)) {
					// 如果不存在id 是添加情况
					if (!file.id) {
						this.addList.push(file.raw)
					}
				} else {
					this.needRefresh ? this.doDelete(file) : ''
				}
			}
		},

		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.acceptType.length > 0) {
				if (this.acceptType.find((x) => x === curType)) {
					return true
				} else {
					this.$message.warning('文件格式不对，请重新选择!')
					return false
				}
			} else {
				return true
			}
		},

		// 文件超出最大个数事件
		onExceed() {
			this.$message.warning('当前最多可上传' + this.maxNum + '个文件！')
		},

		// 查看文件
		doView(file) {
			// fileView(file.id)
			if (this.listType === 'picture-card') {
				this.dialogObj.imgUrl = file.filePath ? this.$uploadUrl + file.filePath : file.url
				this.dialogObj.visible = true
			} else {
				this.$message.info('该文件暂不支持预览!')
			}
		},

		// 下载文件
		doDownload(file) {
			// fileDownload(file.id)
			// this.$message.info('')
			if (file.id) {
				window.open(this.uploadUrl + file.filePath)
			}
		},

		// 删除文件
		doDelete(file) {
			let _index = this.$refs.upload.uploadFiles.findIndex((x) => x.uid === file.uid)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						// this.delList.push(file.id)
						// this.$message.info('移除成功，保存后生效!')

						deleteFile_pay({ id: file.id })
							.then((res) => {
								// console.log(res)
								this.$message.success('删除成功!')
								this.$refs.upload.uploadFiles.splice(_index, 1)
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.addList.splice(
					this.addList.findIndex((x) => x.uid === file.uid),
					1
				)
				this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},

		// 清除文件列表
		clearFiles() {
			this.$refs.upload.clearFiles()
			this.addList = []
			this.delList = []
		},

		// 不需要上传时直接刷新页面
		doRefresh() {
			// this.$message.success('保存成功！')
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			} else {
				this.timer = setTimeout(() => {
					if (!this.$route.path.includes('redirect')) {
						this.$router.replace({
							path: '/redirect' + this.$route.path,
							query: this.$route.query
						})
					}
				}, 1000)
			}
		}
	},
	computed: {
		// 当前文件列表数量
		fileLength() {
			if (!this.isLoaded) {
				return 0
			}
			return this.$refs.upload.uploadFiles.length
		},

		// 支持的文件格式 文字
		acceptMsg() {
			return this.acceptType.length > 0 ? JSON.stringify(this.acceptType) : '所有格式文件'
		},

		// 上传接口地址
		uploadUrl() {
			return this.$uploadUrl
		},

		isMax() {
			console.log(this.fileLength)
			return false
		}
	},
	watch: {
		aid(val) {
			if (val) {
				this.getFiles()
			}
		}
	}
}
</script>

<style lang="less">
.single-upload-layout {
	text-align: left;

	.file-item {
		display: flex;
		justify-content: space-between;
		padding: 0 5px;
		.item-left {
			width: 80%;
			padding: 0 5px;
			box-sizing: border-box;
		}
		.item-right {
			width: 20%;
			text-align: right;
			em {
				cursor: pointer;
			}
		}
	}
	.file-tip {
		font-size: 12px;
		margin-top: 0;
		height: 15px;
		line-height: 15px;
	}
	.el-upload {
		display: unset;
		text-align: left;
	}

	.upload-demo {
		color: #666;
		font-size: 14px;
	}

	.hidden-upload {
		.el-upload {
			display: none !important;
		}
	}

	.picture-demo {
		@color: #4a6ed6;
		.el-upload {
			display: inline-block;
			text-align: center;
			width: 190px;
			height: 120px;
			line-height: 120px;
			color: #4a6ed6;
			border: none;
		}
		.el-upload-list__item {
			width: 190px;
			height: 120px;
			border-color: #eee;
			vertical-align: middle;
		}

		.el-button--text {
			color: @color;
			display: inline-flex;
			justify-content: center;
			align-items: center;
		}

		.el-icon-upload {
			color: @color;
		}

		.img-size {
			width: 190px;
			height: 120px;
		}
		.img-con {
			width: 188px;
			height: 118px;
		}
	}
	.small-box {
		.el-upload {
			width: 128px !important;
			height: 80px !important;
			line-height: 80px !important;
			border: 1px dashed #c0ccda !important;
		}
		.el-upload:hover {
			border: 1px dashed #2671cc !important;
		}
		.img-size {
			width: 128px !important;
			height: 80px !important;
		}
		.el-upload-list__item {
			width: 128px !important;
			height: 80px !important;
			border-color: #eee;
			vertical-align: middle;
		}
	}
}
</style>
